import angular from 'angular';

// ES6 modules are strict by default
const galleriesServices = angular.module('applicationModule.galleriesServices', []);


galleriesServices.factory('Galleries', ['GalleriesAPI', function (GalleriesAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return GalleriesAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return GalleriesAPI.get(id, appId);
        },
        save: function (gallery, editMode) {
            if (editMode) {
                return GalleriesAPI.edit(gallery)
                    .then(function (response) {
                        return response;
                    });
            } else {
                return GalleriesAPI.create(gallery)
                    .then(function (response) {
                        return response;
                    });
            }
        },
        remove: function (id, appId) {
            return GalleriesAPI.remove(id, appId)
                .then(function (response) {
                    return response;
                });
        },
        copy: function (galleryId) {
            return GalleriesAPI.copy(galleryId)
                .then(function (response) {
                    return response;
                });
        }
    };
}]);

galleriesServices.service('GalleriesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/gallery/';

    this.getList = function (appId, params) {
        // Keep application_id as is since it likely matches API requirements
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.create = function (gallery) {
        return $http.post(API_URL + 'create', gallery);
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (gallery) {
        return $http.put(API_URL + 'update/' + gallery.id, gallery);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.copy = function (galleryId) {
        return $http.get(API_URL + 'copy/' + galleryId);
    };
}]);

galleriesServices.factory('GalleryElements', ['GalleryElementsAPI', function (GalleryElementsAPI) {
    'use strict';

    return {
        getList: function (appId, galleryId, params) {
            return GalleryElementsAPI.getList(appId, galleryId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return GalleryElementsAPI.get(id, appId);
        },
        save: function (element, editMode) {
            if (editMode) {
                return GalleryElementsAPI.edit(element)
                    .then(function (response) {
                        return response;
                    });
            } else {
                return GalleryElementsAPI.create(element)
                    .then(function (response) {
                        return response;
                    });
            }
        },
        remove: function (id, appId) {
            return GalleryElementsAPI.remove(id, appId)
                .then(function (response) {
                    return response;
                });
        },
        changeOrder: function (data) {
            return GalleryElementsAPI.changeOrder(data)
                .then(function (response) {
                    return response;
                });
        }
    };
}]);

galleriesServices.service('GalleryElementsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/gallery-element/';

    this.getList = function (appId, galleryId, params) {
        // Keep application_id and gallery_id as is since they likely match API requirements
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                application_id: appId,
                gallery_id: galleryId
            })
        });
    };

    this.create = function (element) {
        return $http.post(API_URL + 'create', element);
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (element) {
        return $http.put(API_URL + 'update/' + element.id, element);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.changeOrder = function (data) {
        const url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

}]);

export default galleriesServices;
